module.exports = __webpack_public_path__ + "img/tabPay.546dc888.png";